import { Badge, Group, Stack, Text } from '@mantine/core'
import { IconClock } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { IconHands } from 'components/Icons/IconHands'

interface SelfAssessmentInfoProps {
  studentScore: number
  studentAssessed: boolean
}

/** Per-student self-assessment column. Shows hand icon + COMPLETED tag once the
 *  student submitted; PENDING badge otherwise. Always read-only for the teacher. */
export function SelfAssessmentInfo({ studentScore, studentAssessed }: SelfAssessmentInfoProps) {
  const { t } = useTranslation()
  const completed = studentAssessed && studentScore > 0
  return (
    <Stack spacing={6}>
      <Group spacing={4} align="center" noWrap>
        <Text size="sm" color="dimmed" style={{ whiteSpace: 'nowrap' }}>
          {t('arc_teacher_assessment_drawer.self_assessment_label')}
        </Text>
        {completed ? (
          <Badge size="sm" color="green">
            {t('arc_teacher_assessment_drawer.self_assessment.completed')}
          </Badge>
        ) : (
          <Badge
            size="sm"
            color="orange"
            leftSection={<IconClock size={12} style={{ display: 'block' }} />}
            styles={{ leftSection: { display: 'flex', alignItems: 'center' } }}
          >
            {t('arc_teacher_assessment_drawer.self_assessment.pending')}
          </Badge>
        )}
      </Group>
      {completed && (
        <IconHands value={studentScore} width={32} height={32} color="var(--mantine-color-gray-7)" />
      )}
    </Stack>
  )
}
